/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{53981429-D850-4CB5-A81A-9B11727A6E2B}",
  "sitecoreApiHost": "https://croatia.upmc.local",
  "graphQLApiHost": "http://cm",
  "clientGraphQLApiHost": "https://croatia.upmc.local",
  "jssAppName": "croatia",
  "coveoAccessToken": "COVEO_SEARCH_API_KEY",
  "coveoOrganizationId": "COVEO_ORGANIZATIONID",
  "coveoPlatformUrl": "https://COVEO_ORGANIZATIONID.org.coveo.com",
  "coveoFarmName": "COVEO_FARM_NAME",
  "coveoSearchHub": "COVEO_SEARCH_HUB",
  "coveoQueryPipeline": "COVEO_QUERY_PIPELINE",
  "defaultLanguage": "hr",
  "graphQLEndpointPath": "/api/croatia",
  "clientGraphQLEndpointPath": "/api/croatia",
  "graphQLEndpoint": "http://cm/api/croatia?sc_apikey={53981429-D850-4CB5-A81A-9B11727A6E2B}",
  "clientGraphQLEndpoint": "https://croatia.upmc.local/api/croatia?sc_apikey={53981429-D850-4CB5-A81A-9B11727A6E2B}"
};